module.exports = {




    // 测试
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9zgeng.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normalgeng.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normalgeng.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketgeng.v3.jiuzhoudaijiaapi.cn:9515?',
    //     'h5': 'https://h5.v3.geng.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }






    // ----------------------------------------- v3 -----------------------------------------

    // 耿师傅线上
    config: {
        'localStorage_token_name': 'access_token',
        'axios_timeout': 20000, // 请求超时时间20秒
        'axios_baseURL': 'https://9z.gsfdj.com',
        'axios_normalURL': 'https://normal.gsfdj.com',
        'axios_imgURL': 'https://normal.gsfdj.com/qiniu/upload',
        'hash_key': 'gcss9csffhhc9z',
        // 'webSocket': 'ws://192.168.100.9:9515?',
        'webSocket': 'wss://socket.gsfdj.com:9515?',
        'h5': 'https://h5.gsfdj.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    }




}